import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SEASONAL_NIGHT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemSeasonalNightMaybe = props => {
  const { lineItems, intl } = props;
  const seasonalLineItems = lineItems.filter(
    item => item.code === LINE_ITEM_SEASONAL_NIGHT && !item.reversal
  );

  return seasonalLineItems.length > 0 ? (
    <React.Fragment>
      {seasonalLineItems.map((item, index) => {
        const quantity = item.quantity?.toString();
        const unitPrice = formatMoney(intl, item.unitPrice);
        const total = formatMoney(intl, item.lineTotal);

        return quantity && total ? (
          <div key={`${item.code}-${index}`} className={css.lineItem}>
            <span className={css.itemLabel}>
              <FormattedMessage
                id="OrderBreakdown.seasonalUnitNight"
                values={{ unitPrice, quantity }}
              />
            </span>
            <span className={css.itemValue}>{total}</span>
          </div>
        ) : null;
      })}
    </React.Fragment>
  ) : null;
};

LineItemSeasonalNightMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemSeasonalNightMaybe;
